import React, { useState } from 'react';
import { ColorRing, InfinitySpin } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const AddOrderSupplierModal = ({toggle, addInternalSupplier, selectedSupplier}) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [status, setStatus] = useState('')

    const handleAddSupplier = async () => {
        if (!selectedSupplier) {
            setError('No supplier selected');
            return;
        }

        setLoading(true)
        setError('')
        setStatus('')
        try {
            await addInternalSupplier(selectedSupplier);
            setTimeout(() => {
                toggle();
            }, 1000)
        } catch (error) {
            const errorMessage = error?.response?.data?.error || 'Failed to add supplier. Please try again.';
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setLoading(false)
        }
    };
    
    const { token, id } = useSelector((state) => state.auth)
    return (
        <div>
            <div className="card sm:w-96 bg-neutral text-neutral-content">
                <div className="card-body items-center text-center">
                    {loading && (
                        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                            <InfinitySpin color="#059212" loading={loading} size={36} />
                        </div>
                    )}
                    <h2 className="font-bold">Add Supplier</h2>

                    <div>
                        <p className='text-xs sm:text-sm'>Are you sure you want to add this supplier?</p>
                        {selectedSupplier && (
                            <div className="mt-2 text-left">
                                <p className="text-xs">Name: {selectedSupplier.name}</p>
                                <p className="text-xs">Contact: {selectedSupplier.phone}</p>
                                <p className="text-xs">Address: {selectedSupplier.address}</p>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center justify-center gap-3 my-2">
                        <button onClick={() => { toggle() }} className="bg-gray-500 font-lufga text-white py-1 text-xs sm:text-sm px-4 rounded-md hover:bg-gray-600 shadow-md transition duration-300">Cancel</button>
                        <button 
                            onClick={handleAddSupplier} 
                            disabled={loading || !selectedSupplier}
                            className="bg-green-500 font-lufga text-white py-1 text-xs sm:text-sm px-4 rounded-md hover:bg-green-600 shadow-md transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            YES
                        </button>
                    </div>
                    <div>
                        {status ? (
                            <div>
                                <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs text-center">{status}</p>
                            </div>
                        ) : error ? (
                            <div>
                                <p className="bg-red-300 font-lufga rounded-md text-center shadow-md px-2 py-1 text-sm">
                                    {error}
                                </p>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddOrderSupplierModal;

